import {
    HttpErrorResponse,
    HttpClient,
    HttpHeaders,
  } from '@angular/common/http';
  import { Injectable } from '@angular/core';
  import { throwError } from 'rxjs';
  import { catchError } from 'rxjs/operators';

  @Injectable({
    providedIn: 'root',
  })
  export class HttpClientGenericService {
    httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    public constructor(private httpClient: HttpClient) {}

    requestPost(url: string, bodyrequest: any) {
      return this.httpClient
        .post(url, bodyrequest, this.httpOptions)
        .pipe(catchError(this.handleError));
    }
    requestGet(url: string) {
      return this.httpClient
        .get(url)
        .pipe(catchError(this.handleError));
    }

    requestDelete(url: string) {
      return this.httpClient
        .delete(url, this.httpOptions)
        .pipe(catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
      if (error.status === 0) {
        // A client-side or network error occurred. Handle it accordingly.
        console.error('An error occurred:', error.error);
      } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong.
        console.error(
          `Backend returned code ${error.status}, body was: `,
          error.error
        );
      }
      // Return an observable with a user-facing error message.
      return throwError(error);
    }
  }
